import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { fetchHiredlyXContent } from "../../../redux/actions/company_action";
import {
  CardContainer,
  CardImage,
  CardListContainer,
  CardText,
  CardTextContainer,
  GridContainerStyled,
  LineBreak,
  TaglineTitle,
} from "./styles";

let query = `
    advantageTitle
    advantageSection {
      title
      description
      image {
        data {
          attributes {
            url
          }
        }
      }
    }
  `;

export default function HXAdvantage() {
  const [solutions, setSolutions] = useState([]);
  const [solutionsCard, setSolutionsCard] = useState([]);

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    const response = await dispatch(fetchHiredlyXContent(query));

    const { advantageTitle, advantageSection } = response || {};
    setSolutions(advantageTitle);
    setSolutionsCard(advantageSection);
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      <TaglineTitle
        dangerouslySetInnerHTML={{ __html: solutions }}
      ></TaglineTitle>

      <CardContainer>
        {solutionsCard?.map((cards, cardIndex) => {
          const imageUrl = cards?.image?.data?.attributes?.url;

          // Decide fallback icon based on index
          let fallbackIcon;
          if (cardIndex === 0) {
            fallbackIcon = (
              <PeopleAltOutlinedIcon
                style={{ fontSize: "2rem", color: "#000" }}
              />
            );
          } else if (cardIndex === 1) {
            fallbackIcon = (
              <WorkOutlineOutlinedIcon
                style={{ fontSize: "2rem", color: "#000" }}
              />
            );
          } else if (cardIndex === 2) {
            fallbackIcon = (
              <LanguageOutlinedIcon
                style={{ fontSize: "2rem", color: "#000" }}
              />
            );
          } else {
            fallbackIcon = null;
          }

          return (
            <>
              <CardListContainer key={cardIndex} cardNumber={cardIndex}>
                {imageUrl ? (
                  <CardImage
                    src={imageUrl}
                    alt={cards?.title || "Card Image"}
                  />
                ) : (
                  fallbackIcon
                )}

                <CardTextContainer>
                  <CardText
                    type={"title"}
                    cardNumber={cardIndex}
                    dangerouslySetInnerHTML={{ __html: cards?.title }}
                  ></CardText>
                  <CardText
                    type={"desc"}
                    cardNumber={cardIndex}
                    dangerouslySetInnerHTML={{ __html: cards?.description }}
                  ></CardText>
                </CardTextContainer>
              </CardListContainer>
              {cardIndex !== solutionsCard.length - 1 && <LineBreak />}
            </>
          );
        })}
      </CardContainer>
    </GridContainerStyled>
  );
}
